import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Modal from "../../components/Modal";
import Alert from "../../components/Alert";
import { listRoles, createRole, updateRole, deleteRole } from "../../api/roleApi";
import "../Users/UsersPage.css";

export default function RolesPage() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [modalMode, setModalMode] = useState(null);
  const [editingRoleId, setEditingRoleId] = useState(null);
  const [roleName, setRoleName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const loadRoles = () => {
    setLoading(true);
    listRoles()
      .then(setRoles)
      .catch(() => setError("Failed to load roles."))
      .finally(() => setLoading(false));
  };

  useEffect(loadRoles, []);

  const openCreate = () => {
    setRoleName("");
    setModalMode("create");
  };

  const openEdit = (role) => {
    setEditingRoleId(role.roleId);
    setRoleName(role.roleName);
    setModalMode("edit");
  };

  const closeModal = () => {
    setModalMode(null);
    setEditingRoleId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      if (modalMode === "create") {
        await createRole({ roleName });
        setSuccess("Role created.");
      } else {
        await updateRole(editingRoleId, { roleName });
        setSuccess("Role updated.");
      }
      closeModal();
      loadRoles();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Something went wrong.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (role) => {
    if (!window.confirm(`Delete role "${role.roleName}"?`)) {
      return;
    }
    setError("");
    try {
      await deleteRole(role.roleId);
      setSuccess("Role deleted.");
      loadRoles();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to delete role.");
    }
  };

  const columns = [{ key: "roleName", label: "Role Name" }];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Roles</h1>
        <button type="button" className="btn-primary" onClick={openCreate}>
          + Add Role
        </button>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          rows={roles}
          actions={(role) => (
            <>
              {!role.superAdminRole && (
                <button type="button" className="btn-link" onClick={() => openEdit(role)}>
                  Edit
                </button>
              )}
              <Link className="btn-link" to={`/admin/permissions?roleId=${role.roleId}`}>
                Permissions
              </Link>
              {!role.superAdminRole && (
                <button type="button" className="btn-link danger" onClick={() => handleDelete(role)}>
                  Delete
                </button>
              )}
            </>
          )}
        />
      )}

      {modalMode && (
        <Modal title={modalMode === "create" ? "Add Role" : "Edit Role"} onClose={closeModal}>
          <form onSubmit={handleSubmit} className="user-form">
            <label>Role Name</label>
            <input value={roleName} onChange={(e) => setRoleName(e.target.value)} required />

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={closeModal}>
                Cancel
              </button>
              <button type="submit" className="btn-primary" disabled={submitting}>
                {submitting ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </Modal>
      )}
    </MainLayout>
  );
}
